import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { cn } from 'lib/utils';
import EmptyState from 'components/EmptyState';
import type { EcmIssue } from 'api/sectorAlignmentApi';
import { ECM_GRID, type Tagged } from './rows';
import EcmRow from './EcmRow';

/** Board 5: accounts and sectors that hide tickets, most severe first (backend order kept). */
const EcmTab = ({ issues, filtered }: { issues: Tagged<EcmIssue>[]; filtered: boolean }) => {
  const { t } = useTranslation();
  if (issues.length === 0 && filtered) return <EmptyState title={t('No result for this filter')} />;
  if (issues.length === 0) return <EmptyState icon={Check} tone="success" title={t('Every sector has a recognised ECM')} />;

  return (
    <>
      <div role="table" aria-label={t('ECM')}>
        <div role="row" className={cn(ECM_GRID, 'h-[42px] border-b text-xs font-semibold text-muted-foreground')}>
          <span role="columnheader">{t('Sector or ECM')}</span>
          <span role="columnheader">{t('Desk')}</span>
          <span role="columnheader">{t('Problem')}</span>
          <span role="columnheader" className="text-right">{t('Action')}</span>
        </div>
        {issues.map((issue, i) => <EcmRow key={`${issue.sd}-${issue.kind}-${i}`} issue={issue} />)}
      </div>
      <p className="border-t px-5 py-[11px] text-[12.5px] text-muted-foreground">{t('After correcting a record, relaunch the analysis.')}</p>
    </>
  );
};

export default EcmTab;
